// ============================================================================
// mediaPlayerParts.tsx — части ЕДИНОГО проигрывателя (SSoT): формат времени
// и волновая дорожка (канвас, клик = переход). Вынесено из MediaPlayer по
// SRP (бюджет строк файла).
// ============================================================================

import { useEffect, useRef } from 'react';

/** Единый набор обработчиков медиа-элемента (audio и video). */
export interface MediaElementHandlers {
  onPlay: () => void;
  onPause: () => void;
  onTimeUpdate: () => void;
  onLoadedMetadata: () => void;
  onEnded: () => void;
  onError: () => void;
  onRateChange: () => void;
}

/** мм:сс (защита от NaN/отрицательных значений). */
export function fmt(t: number): string {
  if (!Number.isFinite(t) || t < 0) return '0:00';
  const m = Math.floor(t / 60);
  const s = Math.floor(t % 60);
  return `${m}:${String(s).padStart(2, '0')}`;
}

/** Waveform-канвас: клик = seek; прогресс — тоном primary. */
export function Waveform({ peaks, progress, onSeek }: { peaks: number[]; progress: number; onSeek: (ratio: number) => void }) {
  const ref = useRef<HTMLCanvasElement>(null);
  useEffect(() => {
    const c = ref.current;
    if (!c || peaks.length === 0) return;
    const ctx = c.getContext('2d');
    if (!ctx) return;
    const w = c.width;
    const h = c.height;
    ctx.clearRect(0, 0, w, h);
    let accent = '#888';
    try {
      const v = getComputedStyle(c).getPropertyValue('--color-primary').trim();
      if (v) accent = v;
    } catch {
      /* canvas вне DOM */
    }
    const n = peaks.length;
    const barW = w / n;
    for (let i = 0; i < n; i++) {
      const amp = Math.max(0.04, Math.min(1, peaks[i]));
      const bh = amp * (h - 2);
      ctx.fillStyle = i / n <= progress ? accent : 'rgba(128,128,128,0.4)';
      ctx.fillRect(i * barW, (h - bh) / 2, Math.max(1, barW - 1), bh);
    }
  }, [peaks, progress]);
  if (peaks.length === 0) return null;
  return (
    <canvas
      ref={ref}
      width={600}
      height={40}
      className="h-10 w-full cursor-pointer"
      onClick={(e) => {
        const r = e.currentTarget.getBoundingClientRect();
        onSeek(Math.min(1, Math.max(0, (e.clientX - r.left) / Math.max(1, r.width))));
      }}
      title="Перейти к позиции"
    />
  );
}
